import React from "react";
import { useNavigate } from "react-router-dom";
import logoFooter from "../../assets/logo-footer.png";
import iconX from "../../assets/icon-x.svg";
import iconLinkedIn from "../../assets/icon-linkedin.svg";
import iconFacebook from "../../assets/icon-facebook.svg";
import iconInstagram from "../../assets/icon-instagram.svg";
import iconTikTok from "../../assets/icon-tiktok.svg";
import "./Footer.css";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <>
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-top">
            <div className="footer-left">
              <div className="footer-links">
                <span onClick={() => handleNavigation("/product")}>
                  All Products
                </span>
                <span onClick={() => handleNavigation("/contact")}>
                  Contact Us
                </span>
                <span onClick={() => handleNavigation("/who-we-are")}>
                  About Us
                </span>
              </div>
            </div>
            <div className="footer-center">
              <img src={logoFooter} alt="Happy Candy Toys Logo" />
            </div>
            <div className="footer-right">
              <div className="social-icons">
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={iconX} alt="X (formerly Twitter)" />
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={iconLinkedIn} alt="LinkedIn" />
                </a>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={iconFacebook} alt="Facebook" />
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={iconInstagram} alt="Instagram" />
                </a>
                <a
                  href="https://tiktok.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={iconTikTok} alt="TikTok" />
                </a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>© 2024 Happy Candy Toys. All rights reserved.</p>
            <div className="footer-terms">
              <span>Terms</span>
              <span>Privacy</span>
              <span>Cookies</span>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-animation-section">
        <div className="footer-semi-circle-animation"></div>
      </div>
    </>
  );
};

export default Footer;
